import React from 'react'
import { Outlet } from 'react-router-dom'

function MainFireExtinguishers() {
  return (
     <div>
       <Outlet/>
     </div>
   )
}

export default MainFireExtinguishers